import React, { FC } from "react";
import {useTypedSelector} from "../reducers";
import bgSubpage from "../assets/images/shine/background_subpage.png";

type ContentVisualProps = {
    title: string;
}

const ContentVisual: FC<ContentVisualProps> = ({ title }) => {
    const { site } = useTypedSelector(state => state.profile);

    return (
        <div className={`content-visual-wrapper ${site}`}
            style={{
                backgroundImage: `url(${bgSubpage})`
                , backgroundSize: 'cover'
                , backgroundPosition: 'center'
                , backgroundRepeat: 'no-repeat'
            }}>
            <span>{title}</span>
        </div>
    );
}

export default ContentVisual;

